import type { DeepPartial } from '@luna/utils-ts';

import type { StatementsConfig } from '../ProductsConfig';
import { config as deliveryChange } from './delivery-change-config/SK';

export const statements: DeepPartial<StatementsConfig> = {
    signed: true,
    deliverySelectable: true,
    creditCardDeliverySelectable: true,
    deliveryEditorVersion: 2,
    modes: {
        electronic: 'ONLY_ELECTRONIC',
        postal: 'PAPER',
    },
    deliveryDefinitions: {
        enabled: true,
        productTypes: ['CURRENT', 'CREDIT', 'SAVING', 'LOAN'],
        showStatementNumberCell: true,
        showFormatWithTranslation: true,
        showFormatField: true,
    },
    tableColumns: {
        DEFAULT: ['NAME', 'TIMESPAN', 'FORMAT', 'DOWNLOAD'],
        CREDIT: ['NAME', 'TIMESPAN', 'FORMAT', 'DOWNLOAD'],
    },
    formDownload: true,
    showDeliveryStatementsInfo: true,
    deliveryChange,
};
